// MUI
import {
  FormControl,
  TextField,
  FormHelperText,
  Button,
  Box,
  Alert,
} from '@mui/material'

// Logic
import useGuestAccessLogic from './GuestAccess.logic'

// Assets
import { MedGEOLogoComponent } from 'assets/MedGEOlogo'

// Other
import { Helmet } from 'react-helmet'
import { Controller } from 'react-hook-form'

// Components
import LoadingState from './LoadingState'

// Styles
import './GuestAccess.scss'

function GuestAccess() {
  const {
    error,
    handleGuestAccess,
    isLoading,
    getValues,
    control,
    handleSubmit,
    errors,
    verificationToken,
    companyId,
    isUpdatingGuestRepInfo,
  } = useGuestAccessLogic()

  // Show loading state when updating guest rep info
  if (isUpdatingGuestRepInfo) {
    return <LoadingState />
  }

  return (
    <div className="guest-access-page">
      <Helmet>
        <title>Guest Access</title>
      </Helmet>

      <div className="auth0-card">
        {error && (
          <Alert
            variant="filled"
            severity="error"
            sx={{ mb: 3, width: '100%' }}
          >
            {error}
          </Alert>
        )}

        <div className="logo-container">
          <MedGEOLogoComponent scale={1.2} />
        </div>

        <div className="auth0-title">Welcome to the MedGEO Platform!</div>
        <div className="auth0-subtitle">
          Please enter your email to continue
        </div>

        <Box
          component="form"
          onSubmit={handleSubmit(handleGuestAccess)}
          sx={{ width: '100%', mb: 0 }}
        >
          <FormControl fullWidth>
            <Controller
              name="email"
              control={control}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  label="Email Address"
                  type="email"
                  fullWidth
                  margin="normal"
                  error={!!errors.email}
                  disabled={isLoading}
                  sx={{ mb: 0 }}
                />
              )}
            />
            <FormHelperText error={!!errors.email}>
              {errors.email?.message}
            </FormHelperText>
          </FormControl>

          <FormControl fullWidth>
            <Controller
              name="confirmEmail"
              control={control}
              rules={{
                required: 'Please confirm your email',
                validate: (value) =>
                  value === getValues('email') || 'Emails do not match',
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  label="Confirm Email Address"
                  type="email"
                  fullWidth
                  margin="normal"
                  error={!!errors.confirmEmail}
                  disabled={isLoading}
                  sx={{ mb: 0 }}
                />
              )}
            />
            <FormHelperText error={!!errors.confirmEmail}>
              {errors.confirmEmail?.message}
            </FormHelperText>
          </FormControl>

          <Button
            fullWidth
            data-testid="guest-access-button"
            variant="contained"
            disableElevation
            type="submit"
            disabled={isLoading || !verificationToken || !companyId}
            className="auth0-button"
            sx={{ mt: 3 }}
          >
            {isLoading ? 'Processing...' : 'Continue as Guest'}
          </Button>
        </Box>
      </div>
    </div>
  )
}

export default GuestAccess
